import { useFairValueContext } from './Context';
import FairValueModal from './FairValueModal';

export const FairValueContainer = () => {
  const { state } = useFairValueContext();
  const { activeWatchlistItem: watchlistItem } = state;

  if (state.isFairValuationModalOpen && watchlistItem) {
    return (
      <FairValueModal
        company={watchlistItem.company}
        defaultUserFairValue={watchlistItem.fairValue}
      />
    );
  }

  return null;
};
